<div class="corner-radius tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.corner-radius' | translate }}
    </h5>
    <div class="corner-radius-input-container">
        <fieldset class="fieldset">
            <input
                #radiusInput
                type="text"
                class="input"
                [ngModel]="radius"
                [type]="radius == MIXED_STRING ? 'text' : 'number'"
                (blur)="handleRadiusChange($event)"
                (keydown)="validRadiusKeyDown($event, true)" />
            <div
                *ngIf="isRectangleSelected"
                class="icon"
                (click)="handleIconClick()"
                [class.highlighted]="showRadiusOption">
                <mat-icon svgIcon="corners" style="cursor: pointer" />
            </div>
        </fieldset>
    </div>
    <ng-container *ngIf="showRadiusOption">
        <h5 class="title">
            {{ 'mimic-drawing.corner-radius.individual' | translate }}
        </h5>
        <div class="individual-radius-container">
            <div class="individual-radius-row">
                <app-editor-input-text
                    name="radius"
                    [value]="corners[TOP_RIGHT_CORNER]"
                    frontIcon="corner-radius"
                    [shouldEmitOnBlur]="true"
                    (onInputChange)="cornerRadiusChanged(TOP_RIGHT_CORNER, $event.value)"
                    (onInputKeyDown)="validRadiusKeyDown($event.event)"
                    [allowDecimal]="false"
                    [minValue]="0">
                </app-editor-input-text>
                <app-editor-input-text
                    name="radius"
                    [value]="corners[TOP_LEFT_CORNER]"
                    frontIcon="corner-radius"
                    [shouldEmitOnBlur]="true"
                    (onInputChange)="cornerRadiusChanged(TOP_LEFT_CORNER, $event.value)"
                    (onInputKeyDown)="validRadiusKeyDown($event.event)"
                    [allowDecimal]="false"
                    [minValue]="0"
                    frontIconRotate="90deg">
                </app-editor-input-text>
            </div>
            <div class="individual-radius-row">
                <app-editor-input-text
                    name="radius"
                    [value]="corners[BOTTOM_RIGHT_CORNER]"
                    frontIcon="corner-radius"
                    [shouldEmitOnBlur]="true"
                    (onInputChange)="cornerRadiusChanged(BOTTOM_RIGHT_CORNER, $event.value)"
                    (onInputKeyDown)="validRadiusKeyDown($event.event)"
                    [allowDecimal]="false"
                    [minValue]="0"
                    frontIconRotate="270deg">
                </app-editor-input-text>
                <app-editor-input-text
                    name="radius"
                    [value]="corners[BOTTOM_LEFT_CORNER]"
                    frontIcon="corner-radius"
                    [shouldEmitOnBlur]="true"
                    (onInputChange)="cornerRadiusChanged(BOTTOM_LEFT_CORNER, $event.value)"
                    (onInputKeyDown)="validRadiusKeyDown($event.event)"
                    [allowDecimal]="false"
                    [minValue]="0"
                    frontIconRotate="180deg">
                </app-editor-input-text>
            </div>
        </div>
    </ng-container>
</div>
